import { render, staticRenderFns } from "./Identities.vue?vue&type=template&id=32698dc4&lang=pug&"
import script from "./Identities.vue?vue&type=script&lang=js&"
export * from "./Identities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports